import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ps-recipe-ingredients" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = {
  key: 0,
  class: "quantity"
}
const _hoisted_4 = {
  key: 1,
  class: "unit"
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 2,
  class: "notes"
}
const _hoisted_7 = {
  key: 1,
  class: "ingredient-item"
}
const _hoisted_8 = {
  key: 0,
  class: "quantity"
}
const _hoisted_9 = {
  key: 1,
  class: "unit"
}
const _hoisted_10 = { class: "name" }
const _hoisted_11 = {
  key: 2,
  class: "notes"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Ingredients", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ingredients, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (_ctx.isSection(item))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h4", _hoisted_2, _toDisplayString(item.name), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ingredients, (ingredient, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${index}-${i}`
                  }, [
                    (ingredient.quantity)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(ingredient.quantity), 1))
                      : _createCommentVNode("", true),
                    (ingredient.unit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(ingredient.unit), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(ingredient.name), 1),
                    (ingredient.notes)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString(ingredient.notes) + ")", 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (item.quantity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.quantity), 1))
                : _createCommentVNode("", true),
              (item.unit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.unit), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.name), 1),
              (item.notes)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(" + _toDisplayString(item.notes) + ")", 1))
                : _createCommentVNode("", true)
            ]))
      ], 64))
    }), 128))
  ]))
}